<template>
  <mdb-row class="my-5">
    <mdb-col md="6" class="mx-auto">
      <mdb-card>
        <mdb-card-body>
          <mdb-card-title v-if="user && user._id"><mdb-icon icon="user-edit"/>
            강사 정보 수정
            <mdb-btn color="primary" icon="lock" class="ml-4 m-0 p-1" @click="modal=true"> 비밀번호 변경</mdb-btn>
          </mdb-card-title>
          <mdb-card-title v-else><mdb-icon icon="user-plus"/> 강사 추가</mdb-card-title>
          <mdb-card-text>
            <profile-edit v-if="user && user._id"
              :user="user" @mode-change="onModeChange" @change-profile="onChangeProfile"/>
            <profile-join v-else-if="user" :user="user" @join="onAddTeacher" />
          </mdb-card-text>
        </mdb-card-body>
      </mdb-card>
      <modal-dlg v-if="modal" size="sm" icon="lock" title="비빌번호 변경" :show="modal"  @close="modal=false">
        <div>
          <mdb-input type="password" label="새 비밀번호" v-model="newPassword"/>
          <mdb-input type="password" label="새 비밀번호 확인" v-model="newPassword2"/>
        </div>
        <div class="text-center">
          <mdb-btn class="py-2 mr-3" color="primary" @click="onChangePassword">변경</mdb-btn>
          <mdb-btn class="py-2" @click="modal=false">닫기</mdb-btn>
        </div>
      </modal-dlg>
    </mdb-col>
  </mdb-row>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbIcon } from 'mdbvue';
import profileEdit from '@/components/auth/ProfileEdit'
import ProfileJoin from '../../../components/auth/ProfileJoin.vue';
import { mapActions, mapState } from 'vuex';
import ModalDlg from '@/components/common/ModalDlg.vue';
export default {
  name: 'StaffTeacherEdit',
  components: { profileEdit, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, ProfileJoin, ModalDlg },
  data: () => ({
    user: undefined,
    editmode: false,
    modal: false,
    newPassword: '',
    newPassword2: ''
  }),
  computed: mapState('auth', ['org']),
  methods: {
    ...mapActions('auth', ['changePasswordByStaff']),
    async onChangeProfile () {
      this.user.org = this.org._id
      await this.user.save()
      this.$router.back()
    },
    onModeChange (value) {
      this.$router.back()
    },
    async onAddTeacher (teacher) {
      if (this.user._id) {
        await this.user.save()
      } else {
        await this.$Auth.join(this.user)
      }
      this.$router.back()
    },
    async onChangePassword () {
      if (this.newPassword !== this.newPassword2) {
        alert('비밀번호 확인이 다릅니다.')
        return
      }
      console.log(this.user._id, this.newPassword)
      await this.changePasswordByStaff({
        _id: this.user._id,
        newPassword: this.newPassword
      })
      this.modal = false
      alert('비밀번호가 변경되었습니다.')
      this.newPassword = ''
      this.newPassword2 = ''
    }
  },
  async created () {
    const { teacher } = this.$route.query
    if (teacher) { // 수정
      this.user = await this.$member.get(teacher)
      console.log('강사', this.user)
    } else {
      const role = 'TEACHER'
      const org = this.org._id
      this.user = this.$member.create({ role, org, name: '' })
    }
  }
}
</script>
